import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import imagenotfound from "../../images/noimagefoundsquare.jpg";

const CardMedia = ({ src, alt, name }) => (
  <div className="relative w-full aspect-square overflow-hidden">
    <img
      src={src || imagenotfound}
      alt={alt}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
      loading="lazy"
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = imagenotfound;
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/35 to-transparent transition-opacity duration-300 group-hover:opacity-100" />

    <CardOverlay name={name} />
  </div>
);

const CardOverlay = ({ name }) => (
  <div className="absolute inset-x-0 bottom-0 p-4">
    <h3 className="text-white font-extrabold text-xl leading-snug drop-shadow-sm line-clamp-2">
      {name}
    </h3>
    <CardCta />
  </div>
);

const CardCta = () => (
  <div className="mt-2 flex items-center justify-between">
    <span className="text-white/95 text-xs font-bold uppercase tracking-wider">
      Voir le profil
    </span>
    <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur-sm group-hover:bg-primary transition-all">
      <ArrowRightIcon className="w-4 h-4" />
    </div>
  </div>
);

export default function CompanyCard({ company }) {
  return (
    <Link
      to={`/compagnie/${company.slug}`}
      className="group  overflow-hidden rounded-2xl border border-gray-200 bg-gray-100 shadow-md hover:shadow-xl hover:border-primary/20 transition-all duration-300"
    >
      <CardMedia
        src={company.imageUrl}
        alt={company.name}
        name={company.name}
      />
    </Link>
  );
}
